// extracted by mini-css-extract-plugin
module.exports = {"root":"controls_root__2Vbwa","btn":"controls_btn__3Zr1B","on":"controls_on__G3xDn","leave":"controls_leave__2z3JG"};